import { useUserRole } from "@/hooks/useUserRole";
import { ControllerDashboardView } from "@/components/controller/dashboards/ControllerDashboardView";
import { PMDashboardView } from "@/components/controller/dashboards/PMDashboardView";
import { FieldDashboardView } from "@/components/controller/dashboards/FieldDashboardView";
import { AccountingDashboardView } from "@/components/controller/dashboards/AccountingDashboardView";
import { BallInCourtView } from "@/components/controller/dashboards/BallInCourtView";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

const RoleDashboard = ({ roleName }: { roleName?: string }) => {
  switch (roleName) {
    case "project_manager":
      return <PMDashboardView />;
    case "field_supervisor":
      return <FieldDashboardView />;
    case "accounting":
      return <AccountingDashboardView />;
    case "controller":
    case "admin":
    default:
      return <ControllerDashboardView />;
  }
};

const ControllerDashboard = () => {
  const { data: roleInfo, isLoading } = useUserRole();

  if (isLoading) {
    return (
      <div className="flex h-64 items-center justify-center">
        <div className="animate-spin h-8 w-8 border-4 border-primary border-t-transparent rounded-full" />
      </div>
    );
  }

  return (
    <Tabs defaultValue="dashboard" className="space-y-4">
      <TabsList>
        <TabsTrigger value="dashboard">Dashboard</TabsTrigger>
        <TabsTrigger value="ball-in-court">🎯 Ball in Court</TabsTrigger>
      </TabsList>
      <TabsContent value="dashboard">
        <RoleDashboard roleName={roleInfo?.roleName} />
      </TabsContent>
      <TabsContent value="ball-in-court">
        <BallInCourtView />
      </TabsContent>
    </Tabs>
  );
};

export default ControllerDashboard;
